import { CalendarViewType, CalendarPayload } from '../schema';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import { DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';

export function getAssetResizeConfiguration(payload: CalendarPayload) {
    const { viewType, calendarIds, connectedAccountCalendarIds, numDaysInDayView } = payload;
    if (
        calendarIds.length === 0 &&
        (!connectedAccountCalendarIds || connectedAccountCalendarIds.length === 0)
    ) {
        // no calendar selected view
        return {
            minHeight: 64,
            defaultHeight: 64,
            maxHeight: 64,
            minWidth: DEFAULT_MIN_ASSET_WIDTH,
            defaultWidth: DEFAULT_MIN_ASSET_WIDTH,
            maxWidth: DEFAULT_MIN_ASSET_WIDTH,
            resizeDisabled: true,
        };
    } else if (viewType === CalendarViewType.Month) {
        return {
            minHeight: 504,
            defaultHeight: 504,
            maxHeight: 504,
            minWidth: DEFAULT_MIN_ASSET_WIDTH,
            defaultWidth: DEFAULT_MIN_ASSET_WIDTH,
            maxWidth: DEFAULT_MIN_ASSET_WIDTH,
            resizeDisabled: true,
        };
    } else if (
        viewType === CalendarViewType.Day ||
        viewType == CalendarViewType.Week ||
        viewType == CalendarViewType.WorkWeek
    ) {
        return {
            minHeight: 335,
            minWidth: numDaysInDayView
                ? (numDaysInDayView - 1) * SurfaceConstants.columnMinWidth + DEFAULT_MIN_ASSET_WIDTH
                : DEFAULT_MIN_ASSET_WIDTH,
        };
    } else {
        // CalendarViewType.Agenda
        return {
            minHeight: 335,
            defaultHeight: 548,
            minWidth: DEFAULT_MIN_ASSET_WIDTH,
        };
    }
}
